import { jsx as _jsx } from "react/jsx-runtime";
import { StyledStackItem } from "./Item.styled";
export var Item = function (_a) {
    var children = _a.children, _b = _a.hasFill, hasFill = _b === void 0 ? false : _b;
    return _jsx(StyledStackItem, { hasFill: hasFill, children: children });
};
